export default "__VITE_ASSET__B4tt7u9o__"